import { useState } from 'react'
import { Helmet } from 'react-helmet-async'

import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'

import Iconify from 'src/components/iconify'
import { useSettingsContext } from 'src/components/settings'

import DreTab from './dre-tab'
import OperatorsTab from './operators-tab'
import CostsTab from './costs-tab'

type FinanceTab = 'dre' | 'operators' | 'costs'

export default function FinanceView() {
  const settings = useSettingsContext()
  const [tab, setTab] = useState<FinanceTab>('dre')

  return (
    <>
      <Helmet>
        <title>Financeiro - Dashboard</title>
      </Helmet>

      <Container maxWidth={settings.themeStretch ? false : 'xl'}>
        <Box
          sx={{
            background: 'linear-gradient(135deg, #064e3b 0%, #0f766e 100%)',
            borderRadius: 2,
            px: { xs: 2, sm: 2.5 },
            py: { xs: 1.5, sm: 2 },
            mb: { xs: 2, md: 3 },
            color: 'white',
          }}
        >
          <Stack direction='row' alignItems='center' spacing={1.5}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 1.5,
                bgcolor: 'rgba(255,255,255,0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Iconify icon='solar:wallet-money-bold' width={22} />
            </Box>
            <Box>
              <Typography variant='h6' fontWeight={700}>
                Financeiro
              </Typography>
              <Typography variant='caption' sx={{ opacity: 0.85 }}>
                DRE por evento — taxas de operadora, custo por máquina e custos lançados
              </Typography>
            </Box>
          </Stack>
        </Box>

        <Tabs value={tab} onChange={(_e, value) => setTab(value)} sx={{ mb: 3 }}>
          <Tab
            value='dre'
            label='DRE'
            icon={<Iconify icon='solar:document-text-bold' width={18} />}
            iconPosition='start'
          />
          <Tab
            value='operators'
            label='Taxas de Operadoras'
            icon={<Iconify icon='solar:card-bold' width={18} />}
            iconPosition='start'
          />
          <Tab
            value='costs'
            label='Custos'
            icon={<Iconify icon='solar:banknote-bold' width={18} />}
            iconPosition='start'
          />
        </Tabs>

        {tab === 'dre' && <DreTab />}
        {tab === 'operators' && <OperatorsTab />}
        {tab === 'costs' && <CostsTab />}
      </Container>
    </>
  )
}
